export default __webpack_public_path__ + "static/media/Member_YuPeiTseng.b4ef8af8.jpg";